import store from '@src/store';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface Props extends RouteComponentProps {
  onReset: () => void;
}

const ErrorMessageView: React.SFC<Props> = ({ onReset, history }) => {
  let directViewLogin = store.getState().userState.directViewLogin;
  return (
    <div className="error-boundary-main">
      <div className="error-message">
        <h4 className="alert-red"><i className="fa fa-exclamation-triangle title mr-2"></i>
          There was an unexpected error on this page. </h4>
          {!directViewLogin && (
            <>
              <h5>Please click below and try again.</h5>
              <span
                className="pointer link-text h5"
                onClick={() => {
                  onReset();
                  history.push('/accounts/summary');
                }}
              >
                Go to Home Page
              </span>
              <span className="h5 ml-1 mr-1">&mdash; or &mdash;</span>
              <span
                className="pointer link-text h5"
                onClick={() => {
                  onReset();
                  history.push('/accounts/customer-service');
                }}
              >
                Contact Customer Service
              </span>
            </>
          )}

      </div>
    </div>
  );
};

export const ErrorMessage = withRouter(ErrorMessageView);
